// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/floik-" + (chunkId === 804 ? "vendor-videojs" : chunkId) + "." + {"146":"aa4b18ae","154":"0cbd8c56","323":"cb500d73","337":"8040738c","578":"c5068835","650":"5457765e","654":"bde81287","724":"234db635","804":"853cbc1f","817":"73cdae47","930":"64477132","963":"8b3772ed"}[chunkId] + ".chunk.css";
};